/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionChecked2: {
  name: 'temp-selection-checked-2';
  data: string;
} = {
  name: 'temp-selection-checked-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.354 5.646a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7 9.293l3.646-3.647a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
